<template>
  <div class="shop_list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        用户列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 70%;margin: 0 auto">
      <div class="goodslist_top">
        <div class="goodslist_title">
          <span>筛选查询</span>
          <div class="download">
            <el-select
              style="margin:0 10px"
              size="small"
              v-model="downloadNumber"
              placeholder="导出数量"
            >
              <el-option
                v-for="item in listNumber"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button size="small" @click="downLoad()">导出店铺信息</el-button>
          </div>

        </div>
         
        <div style="clear:both"></div>  
        <div class="goodslost_seach">
          <el-row class="goodslost_seach_row">
            <el-col :span="6">
              <div class="goodslost_seach_row_col">
                <div>店铺名称:</div>
                <el-input placeholder="店铺名称" v-model="filter_shop_name" style="width:190px" size="small"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="goodslost_seach_row_col">
                <div>审核状态:</div>
                 <el-select v-model="filter_status" clearable placeholder="请选择">
                  <el-option
                    v-for="item in status_list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="12" style="text-align:center">
              <div>
                <el-button size="small" @click="seach()">搜索</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div style="margin-left:16px">
              <i class="fas fa-bars"></i>
              <span style="margin-left:6px">数据列表</span>
            </div>

            <div class="center_list_head_left_div">
              <div class="show_total">
                <el-dropdown trigger="click" @command="change_page_num">
                  <span class="el-dropdown-link show_total_span" style="c">
                    显示条数
                    <i style="font-size: 12px;" class="iconfont icon-sanjiaoxing"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="10">每页10条</el-dropdown-item>
                    <el-dropdown-item :command="15">每页15条</el-dropdown-item>
                    <el-dropdown-item :command="20">每页20条</el-dropdown-item>
                    <el-dropdown-item :command="50">每页50条</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <!-- <div class="show_total" @click="dialogFormVisible1 = true">添加用户</div> -->
            </div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table
        :header-cell-style="{'background':'#F5FAF9'}"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column align="center" prop="shop_name" label="店铺名称" width="120"></el-table-column>
        <el-table-column align="center" prop="username" label="账号" width="150"></el-table-column>
         <el-table-column align="center" prop="uname" label="用户" width="120"></el-table-column>
        <el-table-column align="center" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">个人</span>
          <span v-else>企业</span>
        </template>
        </el-table-column>
          <el-table-column align="center" prop="mobile" label="联系电话" width="180"></el-table-column>
        <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="success">已审核</el-tag>   
          
          <el-tag v-else-if="scope.row.status == 3" type="danger">已禁用</el-tag>
          <el-tag v-else-if="scope.row.status == 2" type="warning">已驳回</el-tag>
          <el-tag v-else type="info">未审核</el-tag>

        </template>
        </el-table-column>
        <el-table-column align="center" prop="create_date" label="创建时间" width="180"></el-table-column>
        <el-table-column label="设置商品数量" align="center">
          <template slot-scope="scope">
            <el-button @click="setGoodsN(scope.row.shop_id)" size="mini">{{scope.row.product_number}}/件</el-button>
          </template>
        </el-table-column> 
        <el-table-column width="200" align="center" label="操作">
          <template slot-scope="scope">
            <span class="binaji" @click="review(scope.row.shop_id)">管理</span>
            <span class="binaji" @click="forbiddens(scope.row.shop_id,scope.row.status)">禁用</span>
            <span class="binaji noticepare" @click="isShowAuth = true,currentAuth(scope.row.shop_id)">增值服务<span v-if="scope.row.service == 1" class="notice"></span></span>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          class="goodslist_bom_page"
          hide-on-single-page
          background
          layout="total , prev, pager, next"
          :page-size="limit"
          :total="total"
          @current-change="pagechange"
        ></el-pagination>
        <!-- hide-on-single-page -->
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 查看申请信息并审核 -->
    <el-dialog
      title="查看入驻商信息"
      :visible.sync="dialogFormVisible1"
      width="30%">
        <el-form ref="ruleForm" label-width="145px" class="demo-ruleForm">
          <el-divider content-position="center">基本信息</el-divider>
          <el-form-item label="店铺名称:">
          <span>{{shopinfo.shop_name}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 1" label="姓名:">
          <span>{{shopinfo.uname}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="公司名称:">
          <span>{{shopinfo.uname}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="公司类型:">
          <span v-if="shopinfo.organ_type == 4">中外合资</span>
          <span v-else-if="shopinfo.organ_type == 3">外企</span>
          <span v-else-if="shopinfo.organ_type == 2">个体户</span>
          <span v-else>私营企业</span>
          </el-form-item>
           <!-- <el-form-item v-show="shopinfo.type == 2" label="组织机构代码:">
          <span>{{shopinfo.organ_code}}</span>
          </el-form-item> -->
          <el-form-item label="联系电话:">
          <span>{{shopinfo.mobile}}</span>
          </el-form-item>
          <el-form-item label="邮箱:">
          <span>{{shopinfo.email}}</span>
          </el-form-item>
          <el-form-item label="联系地址:">
          <span>{{shopinfo.addr}}</span>
          </el-form-item>
          <el-divider v-if="shopinfo.type == 1" content-position="center">身份证信息</el-divider>
          <el-divider v-else content-position="center">企业信息</el-divider>

          <el-form-item v-show="shopinfo.type == 1" label="身份证号:">
          <span>{{shopinfo.id_card}}</span>
          </el-form-item>
           <el-form-item v-show="shopinfo.type == 2" label="统一社会信用代码:">
          <span>{{shopinfo.organ_code}}</span>
          </el-form-item>
          <!-- <el-form-item v-show="shopinfo.type == 2" label="营业执照号码:">
          <span>{{shopinfo.id_card}}</span>
          </el-form-item> -->
          <el-form-item v-show="shopinfo.type == 2" label="法定经营范围:">
          <span>{{shopinfo.organ_area}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 1" label="手持身份证照片:">
          <el-tooltip class="item" effect="dark" content="点击查看大图" placement="right-start">
              <el-image 
                style="width: 160px; height: 100%"
                :src="serve + shopinfo.hand_card_img" 
                :preview-src-list="[serve + shopinfo.hand_card_img]">
              </el-image>
            </el-tooltip>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="企业营业执照:">
            <el-tooltip class="item" effect="dark" content="点击查看大图" placement="right-start">
              <el-image 
                style="width: 160px; height: 100%"
                :src="serve + shopinfo.hand_card_img" 
                :preview-src-list="[serve + shopinfo.hand_card_img]">
              </el-image>
            </el-tooltip>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="法人身份证号:">
          <span>{{shopinfo.id_card}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="法人手持身份证照片:">
            <el-tooltip class="item" effect="dark" content="点击查看大图" placement="right-start">
              <el-image 
                style="width: 160px; height: 100%"
                :src="serve + shopinfo.hand_card_img" 
                :preview-src-list="[serve + shopinfo.hand_card_img]">
              </el-image>
            </el-tooltip>  
          </el-form-item>
          <el-form-item  v-show="shopinfo.type == 1" label="身份证正面:">
            <el-tooltip class="item" effect="dark" content="点击查看大图" placement="right-start">
              <el-image 
                style="width: 160px; height: 100%"
                :src="serve + shopinfo.front_card_img" 
                :preview-src-list="[serve + shopinfo.front_card_img]">
              </el-image>
            </el-tooltip>  
          </el-form-item>
          <el-form-item  v-show="shopinfo.type == 1" label="身份证反面:">
            <el-tooltip class="item" effect="dark" content="点击查看大图" placement="right-start">
              <el-image 
                style="width: 160px; height: 100%"
                :src="serve + shopinfo.back_card_img" 
                :preview-src-list="[serve + shopinfo.back_card_img]">
              </el-image>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="银行开户名:">
          <span>{{shopinfo.bank_uname}}</span>
          </el-form-item>
          <el-form-item label="银行账号:">
          <span>{{shopinfo.bank_card}}</span>
          </el-form-item>
          <el-form-item label="开户银行支行:">
          <span>{{shopinfo.bank_name}}</span>
          </el-form-item>
         
         <el-divider content-position="center">审核</el-divider>
    
          <el-form-item label="平台使用费:">
           <!-- <el-input size="mini" width="20" class="useMoney" placeholder="请输平台使用费" v-model="platform_fee"  clearable></el-input> -->
           <el-input-number size="small" v-model="platform_fee" :precision="2" :step="10" :max="90000"></el-input-number>
          </el-form-item>
          <el-form-item label="保证金:">
          <!-- <el-input size="mini" width="20" class="useMoney" placeholder="保证金" v-model="promise_fee"  clearable></el-input> -->
          <el-input-number size="small" v-model="promise_fee" :precision="2" :step="10" :max="90000"></el-input-number>
          </el-form-item>
          <el-form-item label="佣金比率:">
          <!-- <el-input size="mini" width="20" class="useMoney" placeholder="分成利率" v-model="share_rate"  clearable></el-input> -->
          <el-input-number size="small" v-model="share_rate" :precision="2" :step="0.1" :max="1"></el-input-number>
           <el-tooltip class="item" effect="dark" content="佣金利率即平台抽取佣金比率，平台抽取佣金(20￥) = 成交订单总金额(100￥) X 佣金比率(0.2)" placement="top">
            <span class="el-icon-question" style="margin-left:10px;color:#f39620;font-size:16px"></span>
          </el-tooltip>
          </el-form-item>
          <el-form-item label="立即审核:">
              <el-radio  v-model="status" label="1">审核通过</el-radio>
              <el-radio  v-model="status" label="2">审核驳回</el-radio>
          </el-form-item>
          <el-form-item label="审核信息:">
            <el-input type="textarea" :rows="3" clearable placeholder="请输入审核信息" v-model="return_msg"></el-input>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submitCheck">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="增值服务" :visible.sync="isShowAuth" width="45%">
      <div class="my-service">
      <h4>已开通的服务</h4>
      <div v-if="shopservice && shopservice.length > 0">
        <el-tag v-for="item in shopservice" :key="item">{{item}}</el-tag>
      </div>
      <span class="no-service" v-else>
          尚未开通任何服务!
      </span>
      
      </div>
      <el-divider></el-divider>
      <div v-html="shop_msg"></div> 
      <div v-for="tags in cities" :label="tags.value"  :key="tags.value">
        <h4>{{tags.name }}</h4>
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="city in tags.children" :label="city.value"  :key="city.value">{{city.name}}</el-checkbox>
        </el-checkbox-group> 
      </div>
      
      <div class="check_member">
        <div class="main">
        <h4>审核意见</h4>
        <!-- <el-radio v-model="checkRadio" label="1">同意</el-radio>
        <el-radio v-model="checkRadio" label="2">驳回</el-radio> -->
         <el-radio-group v-model="checkRadio" @change="checkRadioValue" size="small">
          <el-radio label="1" border>同意</el-radio>
          <el-radio label="2" border>驳回</el-radio>
        </el-radio-group>
        </div>
      </div>
      <el-input v-if="checkRadio == '2'" style="margin-bottom:20px"
        type="textarea"
        :rows="2"
        require
        clearable
        placeholder="请输入驳回理由"
        v-model="return_msg">
      </el-input>

      <div><el-button style="margin-left:45%" @click="checkService" :disabled="checkBut" type="primary" >确定</el-button></div>
    </el-dialog>
  </div>
</template>

<script>
const cityOptions = [
  {
    value:1,
    name:'消费者短信通知',
    children: [
        {
          value:'1',
          name:'消费者短信通知',
        },
        {
          value:'2',
          name:'商家短信通知',
        }  
      ]
  },
  {
    value:2,
    name:'代开发票',
    children: [
        {
          value:'3',
          name:'代开发票',
        }
      ]
  },{
    value:3,
    name:'批量导入',
    children: [
        {
          value:'4',
          name:'EXCEL批量导入',
        },
        {
          value:'5',
          name:'智能导入',
        }  
      ]
  }
];
export default {
  name: "list",
  data() {
    return {
      role: true, 
      serve: this.$store.state.serve,
      sy_name: "",
      loading: false,
      shop_name: "222",
      pass: "",
      pass1: "",
      company: "",
      product_number: "",
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      limit: 15,
      page: null,
      total: null,
      tableData: [],
      dialogFormVisible1: false,
      shopinfo: [],
      status: '1',
      return_msg: '',
      shop_id: 0,
      platform_fee: '',
      promise_fee: '',
      share_rate: '',
      filter_status: '',
      filter_shop_name: '',
      status_list: [{
          value: '1',
          label: '审核成功'
        }, {
          value: '3',
          label: '已禁用'
        }],
        forbidden: 1,
        listNumber: [
        { value: 10, label: "10条" },
        { value: 30, label: "30条" },
        { value: 50, label: "50条" },
        { value: 100, label: "100条" },
        { value: 500, label: "500条" },
        { value: 1, label: "全部" }
      ],
      downloadNumber: 10,
      isShowAuth: false,
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: true,
      shop_msg: '',
      applyCheck:[],
      checkRadio:'1', //1成功2驳回
      return_msg:'',
      itemList:['消费者短信通知','商家短信通知','代开发票','EXCEL批量导入','智能导入'],
      shopservice: false,
      checkBut: false, //提交按钮提交一次确定
      shop_apply:'',
    };
  },
  created() {
    this.$store.state.topActiveId = 10;
    this.$store.state.leftTitle = "入驻商列表";
    this.geting();
  },
  watch: {},
  methods: {
    handleCheckedCitiesChange(value) {
      this.applyCheck = JSON.parse(JSON.stringify(value));
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    checkRadioValue (v) {
      if(v == '1'){
        this.return_msg = '';
      }
      this.checkRadio = v;
    },
    currentAuth (shop_id){
        this.checkRadio = '1';
        this.return_msg = '';
        this.shop_id = shop_id
        var that = this; 
        this.axios.get(this.serve + '/admin/serviceStatus',{
          params:{
            username: this.username,
            token: this.token,
            shop_id: shop_id,
          }
        }).then(res=>{
          //console.log(res.data.data.shop_item)
          if(res.data.status == 'success'){
            if(res.data.data.item_status !=null && res.data.data.item_status.status == 0){
               that.shop_msg = "<span class='shop_apply_content'>店铺申请开通的服务项包括："+res.data.data.item_status.content+"</span>";
            }
            that.shop_apply = res.data.data.item_status ? res.data.data.item_status.content : '';
            if(res.data.data.shop_item && res.data.data.shop_item.length >=1){
              var shop_item = res.data.data.shop_item;
              var tagArr = [];
              for(var i=0;i<shop_item.length;i++){
                  tagArr.push(this.itemList[shop_item[i]-1])
              }
              that.shopservice = tagArr;
              //console.log(tagArr);
              //that.checkedCities = res.data.data.shop_item;
            }else{
              that.shopservice = false;
              that.checkedCities = [];
            }
          }
        })
    },
    setGoodsN(shopId){

      this.$prompt('请输入要设置的商户商品数量', '设置', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /[0-9]/,
          inputErrorMessage: '输入必须是数字'
        }).then(({ value }) => {
            this.axios.get(this.serve + '/admin/setProductN',{
              params:{
                username: this.username,
                token: this.token,
                shop_id: shopId,
                product_number: value
              }
            }).then(res=>{
              if(res.data.status == 'success'){
                  this.$message.success('已设置！');
                  this.geting();
              }else{
                  this.$message.success('设置失败！');
              }
            })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              });        
        });
    },
    checkService(){
        if(this.checkRadio == '2' && this.return_msg.trim() == ''){
          this.$message.error('请填写您驳回的原因！');
          return;
        }
        let itemss = Array.from(new Set(this.applyCheck));
        if(this.checkRadio == '1' && itemss.length <=0){
          this.$message.error('请选择你要开通的服务项！');
          return;
        }
        this.checkBut = true;
        this.axios.get(this.serve + '/admin/checkService',{
          params:{
            username: this.username,
            token: this.token,
            shop_id: this.shop_id,
            item: itemss.join(','),
            status: this.checkRadio,
            return_msg: this.return_msg,
            content: this.shop_apply,
          }
        }).then(res=>{
          if(res.data.code == '403'){
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error",
              offset: 300
            });
          }else if(res.data.status == 'success'){
              setTimeout(() => {
                  this.checkBut = false;
              }, 3000);
              this.$message.success('已审核！');
              this.isShowAuth = false;
              this.geting();

          }
        })
    },
    review (id) {
      this.shop_id = id
      this.axios.get(this.serve + '/admin/shopReview',{
        params:{
          username: this.username,
          token: this.token,
          id: id
        }
      }).then(res=>{
        if(res.data.status == 'success'){
          this.status = res.data.data.status
          this.return_msg = res.data.data.return_msg
          this.platform_fee = res.data.data.platform_fee
          this.promise_fee = res.data.data.promise_fee
          this.share_rate = res.data.data.share_rate
          this.shopinfo = res.data.data;
          this.dialogFormVisible1 = true; 
        }
      })
    },
    downLoad (id) { //店铺资料导出
        var where = {
          token: this.token,
          username: this.username,
          limit: this.downloadNumber,
          status: this.filter_status,
          shop_name: this.filter_shop_name
        };
        this.axios.get(this.serve + '/admin/shopDownload',{
          params: where,
          responseType: "blob",
          onDownloadProgress: function(progressEvent) {}
        }).then(res=>{console.log(res)
            if (res.data.type == "text/html") {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              let fileName = "宝枫林店铺信息表.xlsx";
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              this.loading = false;

              this.$message({
                type: "success",
                message: "导出成功成功",
                offset: 200
              });
            }else{
              this.$message({
                showClose: true,
                message: '没有权限',
                type: "error",
                offset: 300
              });
            }
        })
    },
    submitCheck () { //审核店铺信息
        this.axios.get(this.serve + '/admin/checkShop',{
          params:{
            shop_id: this.shop_id,
            status: this.status,
            return_msg: this.return_msg,
            check_member: this.username,
            platform_fee: this.platform_fee,
            promise_fee: this.promise_fee,
            share_rate: this.share_rate
          }
        }).then(res=>{
            if(res.data.status == 'success'){
              this.$message.success(res.data.msg);
              this.dialogFormVisible1 = false
              this.geting()
            }
        })
    },
    setgoods(id) {
      this.$router.push('/admin/shoplook/' + id)
    },
    seach() {
      this.geting();
    },
    pagechange(page) {
      this.geting(page);
    },
    change_page_num(v) {
      this.limit = v;
      this.geting();
    },
    addsubmit() {
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("shop_username", this.shop_name);
      formData.append("pass", this.pass);
      formData.append("pass2", this.pass1);
      formData.append("company", this.company);
      formData.append("product_number", this.product_number);
      this.axios
        .post(this.serve + "/admin/addShop", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            this.geting();
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.dialogFormVisible1 = false;
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    geting(page) {
      this.loading = true;
      this.axios
        .get(this.serve + "/admin/shopApplyLists", {
          params: {
            username: this.username,
            token: this.token,
            page: page,
            limit: this.limit,
            status: this.filter_status,
            shop_name: this.filter_shop_name
          }
        })
        .then(res => {
          if(res.data.code == '403'){
            this.role = false;
          }else{         
            this.tableData = [];
            this.loading = false;
            if (res.data.status == "success") {
              this.page = res.data.data.page;
              this.total = res.data.data.total;
              this.tableData = res.data.data.results;
            }
          }
        });
    },
    forbiddens (shop_id, status) {  //禁用
     if(status == 1){
        var msg = '此操作将使该店铺无法进行任何操作, 是否继续?';
     }else{
        var msg = '确认要恢复店铺正常操作?';
     }
     this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.get(this.serve + '/admin/shopForbiddens',{
            params:{
              username : this.username,
              token : this.token,
              shop_id: shop_id,
              status: status
            }
          }).then(res=>{
            if(res.data.status == 'success'){
              this.geting()
            }else if(res.data.code == '403'){
              this.$message.error(res.data.msg);  
            }
          })
      })
    }
  }
};
</script>
<style lang="scss">
.el-form-item {
    margin-bottom: 5px;
}
.shop_list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .binaji {
    cursor: pointer;
    margin-right: 10px;
    margin-left: 10px;
    font-weight: 300;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
  }
  .binaji:hover {
    color: #0099ff;
  }
  .goodslist_bom_page {
    //  height: 80px;
    padding: 13px 0 30px 0;
    text-align: right;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .goodslist_top {
    border: 1px solid rgba(221, 221, 221, 1);
    .goodslist_title {
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 46px;
      background: rgba(238, 238, 238, 1);
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #333;
      line-height: 46px;
      padding-left: 16px;
      display: flex;
      justify-content: space-between;
      padding-right: 16px;
      align-items: center;
    }
    .goodslost_seach {
      // width: 1060px;
      // line-height: 86px;
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      height: 86px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      .goodslost_seach_row {
        width: 100%;
        .goodslost_seach_row_col {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        }
      }
    }
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  //   .el-pagination {
  //     text-align: left;
  //   }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 70%;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    //  display: flex;
    //  justify-content: space-between;
    .center_list_head_left {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .center_list_head_left_div {
        display: flex;
      }
      .show_total {
        font-size: 12px;
        width: 100px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        text-align: center;
        cursor: pointer;
        line-height: 30px;
        margin-right: 4px;
      }
      .show_total:hover {
        color: #3498db;
      }
      .show_total_span:hover {
        color: #3498db;
      }
    }

    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
  .useMoney{
    width: 148px;
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
.download{
  float: right;
  margin:6px;
}
.shop_apply_content{
  background: #eee;
    width: 100%;
    display: block;
    padding: 10px 2px;
    color: #f64e62;
}
.my-service{
  .el-tag{
     margin-right:5px;
  }
  .no-service{
    color:orange;
  }
}
.check_member{
  margin:20px 0;
  .main{
  }
}
.noticepare{
  position: relative;
  .notice{
    position: absolute;
    top: 0px;
    left: 60px;
    display: block;
    width: 8px;
    height: 8px;
    background: red;
    border-radius: 50%;
  }
}

</style>